import {Typography} from "@mui/material";

export const DpaInfoContent = () => {


    return {
        title: 'Data Point Attributes',
        content: (
            <>
                <Typography paragraph>
                    Data Point Attributes allow Data Points to be
                    categorized, grouped, and organized for reporting,
                    calculations, filtering, and user interfaces.
                </Typography>

                <ul>
                    <li>
                        A Data Point can be assigned one or many
                        Data Point Attributes through Data Point Xrefs.
                    </li>

                    <li>
                        Data Point Attributes make otherwise unrelated
                        Data Points alike by assigning them a common
                        characteristic.
                    </li>

                    <li>
                        For example, both <strong>Basic Cable Revenue</strong> and <strong>Pay TV Revenue</strong> can
                         be assigned
                        the Data Point Attribute of <strong>Revenue</strong>,
                        allowing them to be treated as revenue-related
                        Data Points throughout the system.
                    </li>

                    <li>
                        Additional Data Point Attributes can further
                        classify a Data Point. For example,
                        <strong> Basic Cable Revenue</strong> might be
                        assigned both <strong>Revenue</strong> and
                        <strong> Basic Cable</strong>.
                    </li>

                    <li>
                        This allows reports, grids, and calculations
                        to filter on one attribute while organizing
                        results by another.
                    </li>

                    <li>
                        Data Point Attributes can also belong to
                        Categories such as <strong>Release-To Market</strong>,
                        <strong> Primary</strong>, <strong>Pivot</strong>,
                        and other classifications that have special
                        meaning to the system.
                    </li>

                    <li>
                        Proper use of Data Point Attributes enables
                        flexible reporting and reduces the need to
                        create duplicate Data Points for similar
                        business concepts.
                    </li>
                </ul>
            </>
        )
    };

};